import React, { forwardRef, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { useQuill } from './useQuill';
import './QuillSanitizePaste';
import './TargetLink';


// or const { useQuill } = require('react-quilljs');
import 'quill/dist/quill.snow.css'; // Add css for snow theme
// or import 'quill/dist/quill.bubble.css'; // Add css for bubble theme

const Root = styled('div')(({ style }) => ({
    height: style?.height || 'auto',
    display: 'flex',
    flexDirection: 'column',
    '& .ql-toolbar': {
        flexShrink: 0,
        backgroundColor: '#fff',
        borderBottom: '1px solid #ccc',
    },
    '& .ql-container': {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    '& .ql-editor': {
        maxHeight: style?.height ? 'none' : '500px',
        flex: style?.height ? 1 : 'none',
        minHeight: style?.minHeight ? style?.minHeight : 'auto',
        overflow: 'auto',
    },
  }));


const QuillEditor = forwardRef(
  ({id, readOnly, placeholderText, initialContent, onChange, onSelectionChange, className, articleId, style }, ref) => {

  //Config options
  const allowImages= Boolean(articleId);
  const containerId = 'quill-' + id;
  const bounds= "#" + containerId;
  const theme = 'snow';
  const placeholder = placeholderText ? placeholderText : 'Enter text here...';
  
  const options = useMemo(() => {
    const toolbar = [
      ['bold', 'italic', 'underline', 'strike'],
      [{ align: [] }],
      [{ list: 'ordered'}, { list: 'bullet' }],
      [{ indent: '-1'}, { indent: '+1' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }],
      ['link'],
    ];
    
    if (allowImages) {
      toolbar.push(['image']);
    }
    
    return {
      articleId,
      theme,
      modules: {
        toolbar,
        clipboard: {
          matchVisual: false,
        },
      },
      formats: [
        'bold', 'italic', 'underline', 'strike',
        'align', 'list', 'indent',
        'header',
        'link', 
        'color',
        ...(allowImages ? ['image'] : []),
      ],
      placeholder,
      bounds
    };
  }, [articleId, allowImages, placeholder, bounds]);
  
  //Use hook to initialize quill object
  const { quill, quillRef } = useQuill(options);

  //Set intial value
  useEffect(() => {
    if (quill && initialContent) {
      quill.clipboard.dangerouslyPasteHTML(initialContent);
    }
  }, [quill, initialContent]);
  
  //Update external state on change
  useEffect(() => {
    if (quill) {
      quill.on('text-change', (delta, oldDelta, source) => {
        console.log(quill.getText()); // Get text only
        console.log(quill.getContents()); // Get delta contents
        console.log(quill.root.innerHTML); // Get innerHTML using quill
        console.log(quill.getSemanticHTML());
        onChange(quill.getSemanticHTML());
      });
    }
  }, [quill, onChange]);
  
  


  //editor with container
  return (
    <Root id={containerId} className={clsx('rounded-4 border-1 overflow-hidden w-full', className)} style={style} ref={ref}>
      <div ref={quillRef} style={style?.height ? { height: '100%' } : {}} />
    </Root>
  );
  
});

export default QuillEditor;